import { ADSENSE_CONFIG, isAdsenseConfigured } from '../config/adsenseConfig';

declare global {
  interface Window {
    adsbygoogle?: { push: (config?: object) => void }[];
  }
}

let scriptLoadPromise: Promise<void> | null = null;

/** Load the AdSense script once per page session. */
export function loadAdsenseScript(clientId: string): Promise<void> {
  if (typeof document === 'undefined') {
    return Promise.resolve();
  }

  if (scriptLoadPromise) {
    return scriptLoadPromise;
  }

  scriptLoadPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector(
      'script[src*="pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"]'
    );
    if (existing) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${encodeURIComponent(clientId)}`;
    script.onload = () => resolve();
    script.onerror = () => {
      scriptLoadPromise = null;
      reject(new Error('AdSense script failed to load'));
    };
    document.head.appendChild(script);
  });

  return scriptLoadPromise;
}

/** Request fill for a single <ins class="adsbygoogle"> element. */
export function requestAdsenseFill(): void {
  try {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  } catch (error) {
    console.error('AdSense: failed to request ad fill', error);
  }
}

export function getAdsenseBannerProps(): {
  enabled: boolean;
  clientId: string;
  bannerSlot: string;
} {
  return {
    enabled: isAdsenseConfigured(),
    clientId: ADSENSE_CONFIG.clientId,
    bannerSlot: ADSENSE_CONFIG.bannerSlot,
  };
}
